import { QuestelServicesClient } from '@questelservices/common';
import store from '@/store';
import { FileAuthorizationResult } from '@questelservices/common-vue/dist/models/FileAuthorization';
import { EbillingReportsRequestDto } from '@/models/e-billing/EbillingReportsRequestDto';

export class EbillingService {
  private readonly client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/ebilling');
  }

  public async getEbillingReports(request: EbillingReportsRequestDto): Promise<FileAuthorizationResult> {
    return await this.client.getPostData<FileAuthorizationResult>('', request);
  }
}
